var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.875C9 0.39375 8.595 0 8.1 0H0.9C0.405 0 0 0.39375 0 0.875V6.125C0 6.60625 0.405 7 0.9 7H8.1C8.595 7 9 6.60625 9 6.125V0.875ZM8.1 0.875L4.5 3.0625L0.9 0.875H8.1ZM8.1 6.125H0.9V1.75L4.5 3.9375L8.1 1.75V6.125Z",
    fill: "#BFC3C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c6923c2071d9579f6327cc4a5875e372.svg";
export { ForwardRef as ReactComponent };